import React, { Component } from 'react';
import Chart from "react-apexcharts";
import moment from 'moment';
class Barchart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            options: {
                chart: {
                    type: 'bar',
                    height: 350,
                    stacked: true,
                    toolbar: {
                        show: false
                    }
                },
                dataLabels: {
                    enabled: false
                },
                plotOptions: {
                    bar: {
                        columnWidth: "40%",
                        borderRadius: 5
                    },
                },
                fill: {
                    colors: ['#1877F2', '#0077B5', '#1DA1F2', '#E4405F', '#0088CC', '#FF0000', '#000000']
                },
                colors: ['#1877F2', '#0077B5', '#1DA1F2', '#E4405F', '#0088CC', '#FF0000', '#000000'],
                legend: {
                    position: 'top',
                    horizontalAlign: 'left'
                },
                xaxis: {
                    axisTicks: { show: false },
                    axisBorder: { show: false },
                    categories: props.dates.map((date) => moment(date).format('DD-MM-YYYY')),
                },
                yaxis: {
                    title: {
                        text: 'Records Found'
                    }
                }
            },
            series: [
                {
                    name: "facebook",
                    data: props?.data?.map((item) => item?.facebook),
                },
                {
                    name: "linkedin",
                    data: props?.data?.map((item) => item?.linkdin),
                },
                {
                    name: "twitter",
                    data: props?.data?.map((item) => item?.twitter),
                },
                {
                    name: "instagram",
                    data: props?.data?.map((item) => item?.instagram),
                },
                {
                    name: "telegram",
                    data: props?.data?.map((item) => item?.telegram),
                },
                {
                    name: "youtube",
                    data: props?.data?.map((item) => item?.youtube),
                },
                {
                    name: "tiktok",
                    data: props?.data?.map((item) => item?.tiktok),
                }
            ]
        };
    }
    render() {
        return (
            <div>
                <Chart
                    options={this.state.options}
                    series={this.state.series}
                    type="bar"
                    className="chart-class"
                    // width="100%"
                    height="350px"
                />
            </div>
        );
    }
}

export default Barchart;


